/**
 * CC ATC Drawer Interceptor
 * Converts the CC PDP's native add-to-cart POST (which redirects to /cart)
 * into an AJAX add that opens Atelier's cart drawer.
 *
 * - FormData carries the Photo Upload file natively (multipart via fetch),
 *   so the enctype work survives the AJAX conversion.
 * - The `sections` param replicates Atelier's bundled section rendering
 *   contract: the response includes re-rendered drawer HTML that
 *   cart-items components morph in.
 * - Dispatching the genuine CartAddEvent (via the theme's import map)
 *   drives Atelier's own plumbing: drawer auto-open, bubble count, morph.
 * - Any failure falls back to a native submit — the customer is never
 *   stranded on a dead button.
 */
import { CartAddEvent } from '@theme/events';

const form = document.querySelector('[data-cc-product-form]');

if (form) {
  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const formData = new FormData(form);

    const sectionIds = Array.from(
      document.querySelectorAll('cart-items-component[data-section-id]')
    )
      .map((el) => el.getAttribute('data-section-id'))
      .filter(Boolean);
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    const addUrl =
      (window.Theme && Theme.routes && Theme.routes.cart_add_url) || form.action;

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // /cart/add.js signals errors via a `status` field on a 200-shaped body
        if (data.status) throw new Error(data.description || 'Cart add failed');

        document.dispatchEvent(
          new CartAddEvent({}, 'cc-pdp', {
            source: 'product-form-component',
            productId: data.product_id ? String(data.product_id) : undefined,
            variantId: data.variant_id ? String(data.variant_id) : undefined,
            sections: data.sections,
          })
        );
      })
      .catch(() => {
        // Sold-out race / network error: native submit redirects to /cart
        // where Shopify renders the real error. form.submit() does not
        // re-fire this listener, so no loop.
        form.submit();
      });
  });
}
